var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-center myOrderSwitcher" }, [
    _c(
      "div",
      {
        staticClass: "lighten-3 rounded d-inline-block",
        staticStyle: { transform: "scale(1.2)" },
      },
      [
        _c(
          "v-btn-toggle",
          {
            staticClass: "d-flex myToggle",
            class: {
              "flex-column": _vm.$store.getters.deviceClass.includes("xs"),
              "multiline-toggle": _vm.$store.getters.deviceClass.includes("xs"),
            },
            attrs: { mandatory: false, rounded: "" },
            model: {
              value: _vm.userOrderMode,
              callback: function ($$v) {
                _vm.userOrderMode = $$v
              },
              expression: "userOrderMode",
            },
          },
          [
            _vm.availableModes.includes("inhouse")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "mb-2",
                    class: { "active-mode": _vm.userOrderMode === "inhouse" },
                    attrs: { value: "inhouse", rounded: "" },
                  },
                  [_vm._v(" 🍽️ Zum Hier essen ")]
                )
              : _vm._e(),
            _vm.availableModes.includes("takeAway")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "mb-2",
                    class: { "active-mode": _vm.userOrderMode === "takeAway" },
                    attrs: { value: "takeAway", rounded: "" },
                  },
                  [_vm._v(" 🥡 Zum Abholen ")]
                )
              : _vm._e(),
            _vm.availableModes.includes("delivery") &&
            !_vm.$store.getters.isKiosk &&
            !_vm.$store.getters.inhouse
              ? _c(
                  "v-btn",
                  {
                    class: { "active-mode": _vm.userOrderMode === "delivery" },
                    attrs: { value: "delivery", rounded: "" },
                  },
                  [_vm._v(" 🚚 Zum Liefern ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }